const AUTH_MODE_KEY = 'authMode'
const AUTH_MODE_REGISTERED = 'registered'
const AUTH_MODE_GUEST = 'guest'
const USER_ID_KEY = 'user_id'
const USER_PHONE_KEY = 'userPhone'
const TOKEN_KEY = 'token'
const GUEST_SESSION_KEY = 'guest_session_id'
const GUEST_DISPLAY_KEY = 'guestDisplayId'
const GUEST_EXPIRES_AT_KEY = 'guestExpiresAt'
const LOGIN_FLAG_KEY = 'isLoggedIn'
const CURRENT_SESSION_KEY = 'currentSessionId'

const safeGet = (key) => {
  try {
    return localStorage.getItem(key)
  } catch (error) {
    return null
  }
}

const safeSet = (key, value) => {
  try {
    if (value === undefined || value === null || value === '') {
      localStorage.removeItem(key)
      return
    }
    localStorage.setItem(key, String(value))
  } catch (error) {
    console.warn(`failed to persist ${key}`, error)
  }
}

const safeRemove = (key) => {
  try {
    localStorage.removeItem(key)
  } catch (error) {
    console.warn(`failed to remove ${key}`, error)
  }
}

const maskPhone = (phone) => {
  const normalized = String(phone || '').trim()
  if (!normalized) return ''
  if (normalized.length < 7) return normalized
  return `${normalized.slice(0, 3)}****${normalized.slice(-4)}`
}

const buildGuestDisplayId = (guestSessionId) => {
  const normalized = String(guestSessionId || '').trim()
  if (!normalized) return '游客ID'
  return `游客ID-${normalized.slice(0, 8).toUpperCase()}`
}

const getAuthMode = () => safeGet(AUTH_MODE_KEY) || ''

const isRegisteredMode = () => getAuthMode() === AUTH_MODE_REGISTERED

const isGuestMode = () => getAuthMode() === AUTH_MODE_GUEST

const hasActiveIdentity = () => isRegisteredMode() || isGuestMode()

const getStoredUserId = () => safeGet(USER_ID_KEY)

const getStoredGuestSessionId = () => safeGet(GUEST_SESSION_KEY)

const getStoredGuestDisplayId = () => safeGet(GUEST_DISPLAY_KEY) || buildGuestDisplayId(getStoredGuestSessionId())

const getDisplayName = () => {
  if (isGuestMode()) {
    return getStoredGuestDisplayId()
  }
  return maskPhone(safeGet(USER_PHONE_KEY)) || '未登录'
}

const getAccountLabel = () => {
  if (isGuestMode()) {
    return getStoredGuestDisplayId()
  }
  return maskPhone(safeGet(USER_PHONE_KEY)) || '未登录'
}

const getSessionOwnerParams = () => {
  if (isRegisteredMode() && getStoredUserId()) {
    return { user_id: getStoredUserId() }
  }
  if (isGuestMode() && getStoredGuestSessionId()) {
    return { guest_session_id: getStoredGuestSessionId() }
  }
  return {}
}

const clearGuestState = () => {
  safeRemove(GUEST_SESSION_KEY)
  safeRemove(GUEST_DISPLAY_KEY)
  safeRemove(GUEST_EXPIRES_AT_KEY)
}

const clearRegisteredState = () => {
  safeRemove(USER_ID_KEY)
  safeRemove(USER_PHONE_KEY)
  safeRemove(TOKEN_KEY)
}

const persistGuestAuth = ({ guestSessionId, guestDisplayId, expiresAt }) => {
  clearRegisteredState()
  safeSet(LOGIN_FLAG_KEY, 'true')
  safeSet(AUTH_MODE_KEY, AUTH_MODE_GUEST)
  safeSet(GUEST_SESSION_KEY, guestSessionId)
  safeSet(GUEST_DISPLAY_KEY, guestDisplayId || buildGuestDisplayId(guestSessionId))
  safeSet(GUEST_EXPIRES_AT_KEY, expiresAt || '')
  safeRemove(CURRENT_SESSION_KEY)
}

const persistRegisteredAuth = ({ userId, phone, token }) => {
  clearGuestState()
  safeSet(LOGIN_FLAG_KEY, 'true')
  safeSet(AUTH_MODE_KEY, AUTH_MODE_REGISTERED)
  safeSet(USER_ID_KEY, userId)
  safeSet(USER_PHONE_KEY, phone)
  safeSet(TOKEN_KEY, token)
  safeRemove(CURRENT_SESSION_KEY)
}

const clearAuthState = () => {
  safeRemove(LOGIN_FLAG_KEY)
  safeRemove(AUTH_MODE_KEY)
  safeRemove(CURRENT_SESSION_KEY)
  clearRegisteredState()
  clearGuestState()
}

module.exports = {
  AUTH_MODE_GUEST,
  AUTH_MODE_REGISTERED,
  buildGuestDisplayId,
  clearAuthState,
  getAccountLabel,
  getAuthMode,
  getDisplayName,
  getSessionOwnerParams,
  getStoredGuestDisplayId,
  getStoredGuestSessionId,
  getStoredUserId,
  hasActiveIdentity,
  isGuestMode,
  isRegisteredMode,
  maskPhone,
  persistGuestAuth,
  persistRegisteredAuth
}
